import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import PackageSelectionSection from '../components/PackageSelectionSection';
import AvailabilitySection from '../components/AvailabilitySection';
import NearbyPlacesSection from '../components/NearbyPlacesSection';
import GallerySection from '../components/GallerySection';
import ReviewsSection from '../components/ReviewsSection';
import GoogleMapSection from '../components/GoogleMapSection';
import GoogleReviewsWidget from '../components/GoogleReviewsWidget';
import WhatsAppButton from '../components/WhatsAppButton';
import InstagramButton from '../components/InstagramButton';
import Footer from '../components/Footer';
import AuthModal from '../components/AuthModal'; // Import AuthModal
import DiwaliOfferBanner from '../components/DiwaliOfferBanner';
import CoworkingOfferBanner from '../components/CoworkingOfferBanner';

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'; // Import useAuth

const HomePage = () => {
  const [showPackages, setShowPackages] = React.useState(false);
  const [showAuthModal, setShowAuthModal] = React.useState(false); // Add AuthModal state
  const [selectedPackage, setSelectedPackage] = React.useState(null); // Store selected package
  const { currentUser } = useAuth(); // Get current user
  const handleBookNow = () => setShowPackages(true);
  
  const navigate = useNavigate();
  
  // Handle package selection with authentication check
  const handlePackageSelect = (pkg) => {
    setSelectedPackage(pkg); // Store the selected package
    
    if (currentUser) {
      // If user is logged in, navigate to booking page
      navigate('/booking', { state: { package: pkg } });
    } else {
      // If user is not logged in, show auth modal first
      setShowAuthModal(true);
      
      // Also store in URL parameters as backup and for direct navigation
      const packageParams = new URLSearchParams({
        plan: pkg.plan,
        duration: pkg.duration,
        price: pkg.price.toString(),
        returnTo: 'booking'
      });
      
      // Update URL without navigation to preserve package data
      window.history.replaceState(null, '', `/?${packageParams.toString()}`);
    }
  }
  
  // Handle successful login
  const handleLoginSuccess = () => {
    setShowAuthModal(false);
    // Navigate to booking page with the selected package
    if (selectedPackage) {
      navigate('/booking', { state: { package: selectedPackage } });
    }
  }

  const [bedPrice, setBedPrice] = React.useState(() => {
    const stored = localStorage.getItem('bedPrice');
    return stored ? Number(stored) : 699;
  });
  React.useEffect(() => {
    const handler = () => {
      const stored = localStorage.getItem('bedPrice');
      setBedPrice(stored ? Number(stored) : 699);
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);
  return (
    <div style={{ width: '100vw', minHeight: '100vh', backgroundColor: '#ffffff' }}>
      <Header />
      <DiwaliOfferBanner />
      <CoworkingOfferBanner />
      <HeroSection onBookNow={() => {
        const el = document.getElementById('packages-section');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }} />
      <div id="packages-section">
        <PackageSelectionSection onSelect={handlePackageSelect} />
      </div>
      <div id="availability-section">
        <AvailabilitySection selectedPackage={selectedPackage} />
      </div>
      <NearbyPlacesSection />
      <GallerySection />
      <GoogleMapSection />
      <GoogleReviewsWidget />
      <Footer />
      
      {/* Floating Social Buttons */}
      <WhatsAppButton />
      <InstagramButton />
      
      {/* Auth Modal */}
      <AuthModal 
        isOpen={showAuthModal} 
        onClose={() => setShowAuthModal(false)} 
        onLoginSuccess={handleLoginSuccess}
      />
    </div>
  );
};

export default HomePage;
